export default "__VITE_ASSET__p75xS1dK__"